import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { LIST_ITEM_HEIGHT } from '@/experiences/sales-portal/components/address-search-input/constants';
import { Platform, StyleProp, View, ViewStyle } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface AddressSearchErrorStateProps {
  style?: StyleProp<ViewStyle>;
}

const AddressSearchErrorState: React.FC<AddressSearchErrorStateProps> = ({
  style,
}) => {
  const [styles] = useStyles();

  return (
    <View style={[styles.errorStateContainer, style]}>
      <Typography variant="paragraph-sm">
        {i18n.t('sales_portal.address_search.error')}
      </Typography>
      <Typography variant="paragraph-sm">
        {i18n.t(
          Platform.OS === 'web'
            ? 'sales_portal.address_search.retry_web'
            : 'sales_portal.address_search.retry_native',
        )}
      </Typography>
    </View>
  );
};

export default AddressSearchErrorState;

const useStyles = createStyles((theme) => ({
  errorStateContainer: {
    alignItems: 'center',
    gap: theme.sk.spacing.spaceXsmall,
    justifyContent: 'center',
    minHeight: LIST_ITEM_HEIGHT,
    padding: theme.sk.spacing.spaceMedium,
  },
}));
